<div class="flex flex-col gap-lg py-lg">
  <div [formGroup]="filterForm" class="max-w-64">
    <lib-select
      inputFormControlName="status"
      id="reflection_runs_status_filter"
      name="status"
      [label]="'reflection_runs_status_filter_label' | transloco"
      [options]="statusOptions()"
      [selectedKeyName]="'label'"
      [selectedKeyValue]="'value'" />
  </div>

  @if (failed()) {
    <p
      id="reflection_runs_error"
      role="alert"
      class="rounded-lg border border-destructive-300 bg-destructive-50 p-md text-sm text-destructive-700">
      {{ 'reflection_runs_error' | transloco }}
    </p>
  } @else if (empty()) {
    <p
      id="reflection_runs_empty"
      class="rounded-lg border border-dashed border-neutral-200 bg-neutral-50 p-lg text-center text-sm text-neutral-500">
      {{ 'reflection_runs_empty' | transloco }}
    </p>
  } @else if (rows().length) {
    <div class="overflow-x-auto">
      <table class="w-full text-start text-sm" id="reflection_runs_table">
        <thead>
          <tr class="border-b border-neutral-200 text-neutral-500">
            <th scope="col" class="px-sm py-sm text-start font-medium">
              {{ 'reflection_runs_col_status' | transloco }}
            </th>
            <th scope="col" class="px-sm py-sm text-start font-medium">
              {{ 'reflection_runs_col_event' | transloco }}
            </th>
            <th scope="col" class="px-sm py-sm text-start font-medium">
              {{ 'reflection_runs_col_request' | transloco }}
            </th>
            <th scope="col" class="px-sm py-sm text-start font-medium">
              {{ 'reflection_runs_col_time' | transloco }}
            </th>
            <th scope="col" class="px-sm py-sm text-start font-medium">
              {{ 'reflection_runs_col_attempts' | transloco }}
            </th>
            <th scope="col" class="px-sm py-sm"></th>
          </tr>
        </thead>
        <tbody>
          @for (row of rows(); track row.id) {
            <tr class="border-b border-neutral-100 align-top">
              <td class="px-sm py-sm">
                <div class="flex flex-col items-start gap-xs">
                  <lib-badge
                    [label]="row.statusKey | transloco"
                    [badgeClass]="row.statusClass" />
                  @if (row.skipReasonKey) {
                    <span class="text-xs text-neutral-500">
                      {{ row.skipReasonKey | transloco }}
                    </span>
                  }
                  @if (row.error) {
                    <span class="break-words text-xs text-destructive-700">
                      {{ row.error }}
                    </span>
                  }
                </div>
              </td>
              <td class="px-sm py-sm text-neutral-900">{{ row.event }}</td>
              <td class="px-sm py-sm">
                <a
                  class="text-primary-700 underline"
                  [routerLink]="row.requestLink">
                  {{ row.requestNumber }}
                </a>
              </td>
              <td class="px-sm py-sm text-neutral-700">
                {{ row.createdAt | date: 'dd-MMM-yyyy hh:mm a' }}
              </td>
              <td class="px-sm py-sm text-neutral-700">
                {{ row.attemptCount }}
              </td>
              <td class="px-sm py-sm text-end">
                @if (row.expandable) {
                  <lib-button
                    [id]="'reflection_run_toggle_' + row.id"
                    [label]="
                      (row.expanded
                        ? 'reflection_runs_hide_attempts'
                        : 'reflection_runs_show_attempts'
                      ) | transloco
                    "
                    [btnClass]="'py-xs px-md text-sm rounded-md text-neutral-700 bg-white font-medium border border-neutral-300'"
                    (click)="toggle(row.id)" />
                }
              </td>
            </tr>
            @if (row.expanded) {
              <tr class="border-b border-neutral-100 bg-neutral-50">
                <td colspan="6" class="px-md py-sm">
                  <ul class="flex flex-col gap-sm">
                    @for (attempt of row.attempts; track attempt.attempt) {
                      <li
                        class="flex flex-col gap-xs rounded-md border border-neutral-200 bg-white p-sm">
                        <div class="flex flex-wrap items-center gap-sm">
                          <span class="font-medium text-neutral-900">
                            {{
                              'reflection_runs_attempt_label'
                                | transloco: { number: attempt.attempt }
                            }}
                          </span>
                          <lib-badge
                            [label]="attempt.statusKey | transloco"
                            [badgeClass]="attempt.statusClass" />
                          @if (attempt.startedAt) {
                            <span class="text-xs text-neutral-500">
                              {{
                                attempt.startedAt | date: 'dd-MMM-yyyy hh:mm a'
                              }}
                            </span>
                          }
                          @if (attempt.durationMs !== null) {
                            <span class="text-xs text-neutral-500">
                              {{
                                'reflection_runs_attempt_duration'
                                  | transloco: { ms: attempt.durationMs }
                              }}
                            </span>
                          }
                        </div>
                        @if (attempt.responseStatus !== null) {
                          <p class="text-xs text-neutral-700">
                            {{
                              'reflection_runs_attempt_response_status'
                                | transloco
                            }}:
                            <span class="font-medium">
                              {{ attempt.responseStatus }}
                            </span>
                          </p>
                        }
                        @if (attempt.error) {
                          <p class="break-words text-xs text-destructive-700">
                            {{ attempt.error }}
                          </p>
                        }
                      </li>
                    }
                  </ul>
                </td>
              </tr>
            }
          }
        </tbody>
      </table>
    </div>

    @if (totalPages() > 1) {
      <lib-paginator
        [nextBtnLabel]="'pagination_next_button_label' | transloco"
        [previousBtnLabel]="'pagination_previous_button_label' | transloco"
        [currentPage]="page()"
        [totalPages]="totalPages()"
        [totalItems]="meta()?.total"
        [pageItemCount]="runs().length"
        (goTo)="goTo($event)"
        (next)="goTo($event)"
        (previous)="goTo($event)" />
    }
  }
</div>
